module.exports = __webpack_public_path__ + "static/media/drone.19c04f0f.svg";